module.exports = __webpack_public_path__ + "static/img/15.5df6313.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/15.png
// module id = wRpw
// module chunks = 0